"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BillingDetails;

var React = _interopRequireWildcard(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}
/* eslint-disable */


function BillingDetails(props) {
  var color = props.color,
      size = props.size,
      customColor = props.customColor,
      className = props.className,
      dataTest = props.dataTest,
      ariaHidden = props.ariaHidden,
      ariaLabel = props.ariaLabel,
      reverseOnRtl = props.reverseOnRtl;
  return React.createElement(_Icon.default, {
    viewBox: "0 0 24 24",
    size: size,
    color: color,
    customColor: customColor,
    className: className,
    dataTest: dataTest,
    ariaHidden: ariaHidden,
    reverseOnRtl: reverseOnRtl,
    ariaLabel: ariaLabel
  }, React.createElement("path", {
    d: "M19.547 2.21l-3.45 2.051c-.28.186-.746.186-1.025-.093L12.368 2.21c-.373-.28-.746-.28-1.12 0l-2.61 1.958c-.28.186-.653.28-1.025.093L4.256 2.21c-.373-.187-.746 0-.746.373v18.834c0 .373.373.56.746.373l3.45-2.051c.28-.187.746-.187 1.025.093l2.704 1.958c.373.28.746.28 1.12 0l2.703-1.958c.28-.186.746-.28 1.026-.093l3.45 2.051c.28.187.746 0 .746-.373V2.583c-.187-.373-.56-.56-.933-.373zM7.24 7.338h3.73c.559 0 .932.373.932.932s-.373.933-.933.933H7.24c-.559 0-.932-.373-.932-.933s.373-.932.933-.932zm0 3.73h1.864c.56 0 .933.373.933.932s-.373.932-.933.932H7.24c-.56 0-.933-.373-.933-.932s.373-.932.933-.932zm5.594 5.594H7.24c-.56 0-.933-.373-.933-.932s.373-.933.933-.933h5.594c.56 0 .932.373.932.933s-.373.932-.932.932zm3.73 0h-.933c-.56 0-.932-.373-.932-.932s.373-.933.932-.933h.933c.56 0 .932.373.932.933s-.373.932-.932.932zm0-3.73h-.933c-.56 0-.932-.373-.932-.932s.373-.932.932-.932h.933c.56 0 .932.373.932.932s-.373.932-.932.932zm0-3.73h-.933c-.56 0-.932-.372-.932-.932s.373-.932.932-.932h.933c.56 0 .932.373.932.932s-.373.933-.932.933z"
  }));
}